var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-container pa-2",
      style: {
        left: _vm.horizontal + "px",
        top: _vm.vertical + "px",
        backgroundColor: "white"
      }
    },
    _vm._l(_vm.menuOptions, function(option) {
      return _c(
        "div",
        {
          key: option.action,
          staticClass: "d-flex align-center pa-2 menu-item",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClick(option.action)
            }
          }
        },
        [
          _c("v-icon", { staticClass: "menu-icon" }, [
            _vm._v(_vm._s(option.icon))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "menu-option" }, [
            _vm._v(_vm._s(option.label))
          ])
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc90c326", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc90c326","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/menus/TrayConnectionMenu.vue
// module id = null
// module chunks = 